import React, { useState, useEffect } from "react";
import styled from "styled-components";

import { DetailsLayout } from "components/akapBigas/detailsLayout";
import { useLocation } from "react-router-dom";
import { format, parseISO } from "date-fns";
import { modifiedFormatMoney } from "utils/money";

const Container = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
`;

const DetailsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

const MoneyContainer = styled.div`
  color: #1cc716ff;
  font-size: 20px;
  font-weight: 600;
`;

const MoneyDetails = styled.div`
  font-size: 12px;
  color: #000000;
  font-weight: 400;
`;

const ReferenceLabel = styled.div`
  color: #969696;
  font-size: 12px;
`;

const ReferenceValue = styled.div`
  color: #000000;
  font-size: 14px;
  font-weight: 700;
`;

const DescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 14px;
  border-bottom: 1px solid #e3e3e3;
  padding-top: 14px;
  padding-bottom: 14px;
`;
const DescriptionValue = styled.div`
  color: #000000;
  font-size: 14px;
`;

const DateTimeContainer = styled.div`
  color: #4d4d4d;
  font-size: 12px;
  display: flex;
  margin-top: 25px;
  justify-content: center;
`;

const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 200px;
  color: #969696;
  font-size: 16px;
`;

const PaymentDetails = () => {
  const [details, setDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const paymentData = location.state?.log;

  useEffect(() => {
    // Try to get transaction details from navigation state
    setDetails(paymentData);
    setLoading(false);
   
  }, []);

  if (loading) {
    return (
      <DetailsLayout title="Payment Received" isCloseButton={true}>
        <LoadingContainer>Loading transaction details...</LoadingContainer>
      </DetailsLayout>
    );
  }

  return (
    <DetailsLayout title="Payment Received" isCloseButton={true}>
      <Container>
        <DetailsContainer>
          <div>
            <MoneyContainer>
              {details?.type === "payment" ? (
                <span style={{ color: "#1ba833", fontWeight: "bold" }}>
                  +{modifiedFormatMoney(details?.amount || 0)}
                </span>
              ) : (
                modifiedFormatMoney(details?.amount || 0)
              )}
            </MoneyContainer>
            <MoneyDetails>{details?.name}</MoneyDetails>
          </div>
          <div>
            <ReferenceLabel>Reference Number</ReferenceLabel>
            <ReferenceValue>{details?.id}</ReferenceValue>
          </div>
        </DetailsContainer>
        <DescriptionContainer>
          <div>
            <ReferenceLabel>Description</ReferenceLabel>
            <DescriptionValue>Payment received from {details?.name}</DescriptionValue>
          </div>
        </DescriptionContainer>
        <DateTimeContainer>
          <div>
            {details?.created_at
              ? format(parseISO(details?.created_at), "MMM dd, yyyy h:mma")
              : "Date not available"}
          </div>
        </DateTimeContainer>
      </Container>
    </DetailsLayout>
  );
};

export default PaymentDetails;
